const keywordKeys = Object.freeze({
  required: 'required',
  minLength: 'min_length',
  maxLength: 'max_length',
  minimum: 'min',
  maximum: 'max',
  exclusiveMinimum: 'exclusive_min',
  exclusiveMaximum: 'exclusive_max',
  multipleOf: 'multiple_of',
  minItems: 'min_items',
  maxItems: 'max_items',
  minProperties: 'min_properties',
  maxProperties: 'max_properties',
  pattern: 'pattern',
  format: 'format',
  enum: 'enum',
  const: 'const',
  uniqueItems: 'unique_items',
  additionalProperties: 'additional_properties',
  propertyNames: 'property_names',
  dependencies: 'dependencies',
  contains: 'contains',
  anyOf: 'conditional',
  oneOf: 'conditional',
  if: 'conditional',
  not: 'not_allowed',
});

const limitParams = Object.freeze({
  minLength: 'minLength',
  maxLength: 'maxLength',
  minimum: 'min',
  maximum: 'max',
  exclusiveMinimum: 'min',
  exclusiveMaximum: 'max',
  minItems: 'minItems',
  maxItems: 'maxItems',
});

export function getActualAjvError(error) {
  if (error.keyword === 'errorMessage' && error.params.errors.length) {
    return getActualAjvError(error.params.errors[0]);
  }
  return error;
}

// Match Portal/CMS: schemas supply custom keys; AJV supplies interpolation values.
export function ajvErrorToTranslationKey(error) {
  const actualError = getActualAjvError(error);
  const { keyword } = actualError;
  const params = { ...actualError.params };
  const limitParam = limitParams[keyword];
  if (limitParam) {
    params[limitParam] = params.limit;
  }
  if (keyword === 'enum') {
    params.allowedValues = params.allowedValues.join(', ');
  }
  if (error.keyword === 'errorMessage') {
    return { key: error.message, params };
  }
  if (keyword === 'type') {
    if (
      ['string', 'number', 'integer', 'boolean', 'array', 'object', 'null'].includes(params.type)
    ) {
      return { key: `shared.validation.type_${params.type}`, params };
    }
    return { key: 'shared.validation.invalid', params };
  }
  if (keyword === 'format' && ['email', 'uri', 'date', 'time'].includes(params.format)) {
    return { key: `shared.validation.format_${params.format}`, params };
  }
  return { key: `shared.validation.${keywordKeys[keyword] || 'invalid'}`, params };
}

export function translateAjvError(error, t) {
  const { key, params } = ajvErrorToTranslationKey(error);
  return t(key, params);
}
